<template lang="html">
  <div
    class="md:h-screen py-24 sm:pt-48"
    >
    <Background class="z-0 overflow-hidden" :colour="randomColour" />
    <div class="z-30 relative">
    <MainHeader />
    <ResultPage />
    <MainFooter
    :bgcolour="bgcolour"
    />
    </div>
  </div>
</template>

<script>
import ResultPage from "@/components/result/ResultPage.vue"
import MainHeader from "@/components/header/MainHeader.vue"
import Background from "@/components/bg/Background.vue"
import MainFooter from "@/components/footer/MainFooter.vue"

  export default {
    name:"Result",
    components: {
      MainFooter,
      Background,
      MainHeader,
      ResultPage
    },
    data() {
      return {
       randomColour: { bg: "herocream", img: require('@/assets/img/SVG/BGvanilla.svg') }
      }
    }
  }
</script>

<style lang="css">
</style>
